import React, {Component} from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import {processStringContent} from 'utils/content'


class MatchingItem extends Component {
    getStyle = () => {
        const style = {
        }
        if (this.props.match_color) {
            style.borderColor = this.props.match_color
        }

        return style
    }

    renderImage() {
        const {image_url, image_alt} = this.props.item_data

        if (!image_url) {
            this.props.itemReady()
            return null
        }

        return (
            <div className="cc-matching-item-content-image">
                <img src={image_url} alt={image_alt} onLoad={this.props.itemReady} />
            </div>
        )
    }

    renderContent() {
        const {html_content_1, html_content_2} = this.props.item_data

        return (
            <div className="cc-matching-item-content">
                {processStringContent(html_content_1)}
                {this.renderImage()}
                {processStringContent(html_content_2)}
            </div>
        )
    }

    render() {
        const item_id = `matching-${this.props.item_group}-${this.props.item_data.id}`
        const class_name = classNames('cc-matching-item', {
            'cc-matching-item-active': this.props.is_active,
            'cc-matching-item-matched': this.props.is_matched
        })
        return (
            <div id={item_id} className={class_name} style={this.getStyle()} onClick={this.props.onClick}>
                {this.renderContent()}
            </div>
        )
    }
}

MatchingItem.propTypes = {
    item_data: PropTypes.object.isRequired,
    item_group: PropTypes.string.isRequired,
    is_active: PropTypes.bool.isRequired,
    is_matched: PropTypes.bool.isRequired,
    match_color: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    itemReady: PropTypes.func.isRequired
}

export default MatchingItem